import { render, staticRenderFns } from "./GooglePluginReminder.vue?vue&type=template&id=72f7069c&scoped=true&"
import script from "./GooglePluginReminder.vue?vue&type=script&lang=js&"
export * from "./GooglePluginReminder.vue?vue&type=script&lang=js&"
import style0 from "./GooglePluginReminder.vue?vue&type=style&index=0&id=72f7069c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f7069c",
  null
  
)

export default component.exports